function defineProps(constructor) {
    if (!constructor.__attrsMap) {
        const props = constructor.properties;
        const attrsMap = Object.create(null);
        if (props) {
            for (const name in props) {
                attrsMap[name.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase()] = name;
                Object.defineProperty(constructor.prototype, name, {
                    get() {
                        return this.__props[name];
                    },
                    set(newValue) {
                        const oldValue = this.__props[name];
                        this.__props[name] = newValue;
                        this.rendered &&
                            oldValue !== newValue &&
                            this.update();
                    }
                });
            }
        }
        constructor.__attrsMap = attrsMap;
        constructor.__observedProps = Object.keys(attrsMap);
    }
    return constructor.__observedProps;
}
export function withProps(Base) {
    return class extends Base {
        constructor() {
            super(...arguments);
            this.__props = Object.create(null);
        }
        static get observedAttributes() {
            return defineProps(this);
        }
        attributeChangedCallback(name, _, newValue) {
            const { __attrsMap, properties } = this.constructor;
            this[__attrsMap[name]] = properties[name](newValue);
        }
    };
}
